import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';
import type { PayDebtConfirmation as Props } from './pay-debt-confirmation.types';

const PayDebtConfirmation: React.FunctionComponent<Props> = ({
  details,
  layout,
}) => (
  <FlowTerminusLayout {...layout}>
    <div className="pay-debt-confirmation">
      {details ? (
        <div className="pay-debt-confirmation__details-container">
          <Text
            elementName="h2"
            theme={Text.themes.headline}
            size={Text.sizes.large}
          >
            {details.title}
          </Text>
          <div className="pay-debt-confirmation__details">
            <Text theme={Text.themes.emphasis}>{details.amount.text}</Text>
            <div className="pay-debt-confirmation__details-price">
              <Text
                elementName="span"
                size={Text.sizes.headline2}
                theme={Text.themes.emphasis}
              >
                {details.amount.price}
              </Text>
              <Text elementName="span" theme={Text.themes.emphasis}>
                {details.amount.currency}
              </Text>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  </FlowTerminusLayout>
);

export default PayDebtConfirmation;
